import React, { useState, useEffect } from 'react';
import { Stack, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import 'maplibre-gl/dist/maplibre-gl.css';
import 'leaflet/dist/leaflet.css';
import { TypographyTitleLarge } from '../style/typography'
import '../style/legend_risk.css';
import { FONT_COLOR } from '../const/general'
import { RIVER_LEVEL_LEGEND, BSN_AVERAGE_LEGEND } from '../const/legend'
import LineRiver from './line_river';
import BarLine from './bar_line';
import CommonCard from '../item/common_card';

export default function RiverRisk(props) {
    const [bsnRiskFontColor, setBsnRiskFontColor] = useState(props.levelPoint.LEVEL_1);
    const [bsnRisk, setBsnRisk] = useState('平常');
    const [name, setName] = useState();
    const [txtRiverName, setTxtRiverName] = useState();
    const [pct, setPct] = useState();
    const [mtr, setMtr] = useState();
    const [categoryDates, setCategoryDates] = useState([]);

    const setLabel = (POINT, risk_max) => {
        // 表示文言の設定
        if (POINT.LEVEL_6 <= risk_max) {
            setBsnRisk('氾濫危険水位')
        } else if (POINT.LEVEL_5 <= risk_max) {
            setBsnRisk('避難判断水位')
        } else if (POINT.LEVEL_4 <= risk_max) {
            setBsnRisk('氾濫注意水位')
        } else if (POINT.LEVEL_3 <= risk_max) {
            setBsnRisk('水防団待機水位')
        } else if (POINT.LEVEL_2 <= risk_max) {
            setBsnRisk('平常')
        } else {
            setBsnRisk('欠測')
        }
    }

    // 情報を格納
    const setInfo = (risk_max) => {
        if (risk_max === null) {
            setBsnRisk('-')
            setBsnRiskFontColor('white')
            return
        }
        // 文字色の設定
        setBsnRiskFontColor(props.setColor(risk_max))
        // 表示文言の設定
        setLabel(props.levelPoint, risk_max)
        setName(props.maxValInfo.name)
        setTxtRiverName(props.maxValInfo.txt_river_name)
        setPct(props.maxValInfo.pctMax)
        setMtr(props.maxValInfo.mtrMax == null ? '-' : props.maxValInfo.mtrMax)
        const allDateTime = getDateTime(props.telDateArray);
        setCategoryDates(allDateTime)
    }

    const getDateTime = (date_ary) => {
        const last00 = [...date_ary].reverse().find(time => time.endsWith("00"));
        const [hour, minute] = last00.split(":").map(Number);
        const baseTime = new Date(2024, 0, 1, hour, minute);
        const futureTimes = [];

        // 10分ごとの15時間先までの時間を取得
        for (let i = 1; i <= 90; i++) {
            const next = new Date(baseTime.getTime() + i * 10 * 60 * 1000);
            const hh = String(next.getHours()).padStart(2, "0");
            const mm = String(next.getMinutes()).padStart(2, "0");
            const timeStr = `${hh}:${mm}`;
            // 既に含まれていないものだけ追加
            if (!date_ary.includes(timeStr)) {
                futureTimes.push(timeStr);
            }
        }
        const allDateTime = [...date_ary, ...futureTimes];
        return allDateTime;
    };

    // 複合グラフのマーカー情報
    const getPoints = (date_ary, data_x) => {
        let points = []
        for (let i = 0; i < data_x.length; i++) {
            const point = {
                x: date_ary[i],
                y: data_x[i],
                marker: {
                    size: 4,
                    fillColor: '#8794f2',
                    strokeColors: '#8794f2',
                    strokeWidth: 1,
                    shape: "circle"
                }
            }
            points.push(point)
        }
        return points
    }

    // ヒートマップの数値表示変換処理
    const format = (val) => `${val?.toFixed(2)}`;

    // 定期監視用
    useEffect(() => {
        if (Array.isArray(props.allRankData) && props.allRankData.length === 0) {
            setName("-");
            setTxtRiverName("-");
            setBsnRisk("-");
            setBsnRiskFontColor("white");
            setPct("-");
            setMtr("-");
            setCategoryDates([]);
            return;
        }

        if (props.maxValInfo !== null && props.maxValInfo !== undefined) {
            setInfo(props.maxValInfo.riskMax);
        }
    }, [props.allRankData, props.maxValInfo, props.telDateArray]);

    return (
        <>
            <Grid container
                spacing={1}
                columns={12}
                pt={1} pb={1} pr={1}
                // height={'100%'}
                sx={{ height: '100%', width: '100%', padding: 0, m: 0 }} // Grid全体の高さ100%
            >
                <Grid size={{ xs: 12, sm: 12, md: 12 }} sx={{ mb: { xs: 1, sm: 1, md: 1.5 } }}>
                    <Stack spacing={0} height={{ xs: '100%', sm: 'calc(5dvh - 36px - 9px - 108px)' }}>
                        <Typography
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '30px',
                                color: FONT_COLOR,
                                fontSize: {
                                    xs: '1.75rem',
                                    sm: '1.75rem',
                                    md: 'clamp(1.5rem, -0.3rem + 1.2vw, 2rem)'
                                },
                                fontWeight: 'bold',
                                marginLeft: '10px',
                                padding: '5px'
                            }}
                        >
                            <Box component="span">{`${name}`}</Box>
                            <Box component="span">{`${txtRiverName}`}</Box>
                        </Typography>
                    </Stack>
                </Grid>

                <Grid size={{ xs: 12, sm: 7, md: 6 }}>
                    <CommonCard
                        child={
                            <TypographyTitleLarge sx={{ color: bsnRiskFontColor }}>{`${bsnRisk}`}</TypographyTitleLarge>
                        }
                        title='危険度'
                        xsHeight="45px"
                        height="40px"
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 7, md: 3 }}>
                    <CommonCard
                        child={
                            <TypographyTitleLarge sx={{ color: bsnRiskFontColor }}>{`${pct}`}</TypographyTitleLarge>
                        }
                        title='水位パーセント'
                        xsHeight="45px"
                        height="40px"
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 7, md: 3 }}>
                    <CommonCard
                        child={
                            <TypographyTitleLarge sx={{ color: bsnRiskFontColor }}>{`${mtr}`}</TypographyTitleLarge>
                        }
                        title='水位(m)'
                        xsHeight="45px"
                        height="40px"
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <CommonCard
                        child={
                            <>
                                {RIVER_LEVEL_LEGEND()}
                                <LineRiver
                                    limitVal={500}
                                    dateArray={props.telDateArray}
                                    maxMtrDatetime={props.maxMtrDatetime}
                                    maxValInfo={props.maxValInfo}
                                    categoryDates={categoryDates}
                                    isReadyKey={['line_river']}
                                    isReadyFlg={props.isReadyLineFlg}
                                    setReady={props.setReady}
                                />
                            </>
                        }
                        xsHeight="200px"
                        title={"観測時間ごとの流域雨量、流域平均流出量、および河川水位"}
                        // height='100%'
                        height='calc(40dvh - 36px - 17px - 8px - 31px)'
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <CommonCard
                        child={
                            <>
                                {BSN_AVERAGE_LEGEND()}
                                <BarLine
                                    limitVal={15}
                                    dateArray={props.dateArray}
                                    xDatetime={props.bsnAverageDatetime}
                                    yDatetime={props.bsnAverageH24Datetime}
                                    getPoints={getPoints}
                                    seriesNameX={'流域平均流出量'}
                                    seriesNameY={'流域平均24時間雨量'}
                                    colors={['#8794f2', '#4857c4']}
                                    strokeColors={['#8794f2', 'transparent']}
                                    shared={true}
                                    intersect={false}
                                    format={format}
                                    bottom={-30}
                                    height={'calc(100%)'}
                                    isReadyKey={['bar_line_river']}
                                    isReadyFlg={props.isReadyBarLineFlg}
                                    setReady={props.setReady}
                                    chooseNum={12}
                                />
                            </>
                        }
                        xsHeight="200px"
                        height='calc(40dvh - 36px - 17px - 8px - 31px)'
                    />
                </Grid>
            </Grid>
        </>
    )
};